import * as React from 'react';

export default function IconEmail({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.1738 5.21875H18.295V5.2196C19.4783 5.2196 20.4697 6.21103 20.4313 7.3934V16.6632C20.4313 17.8455 19.4399 18.837 18.2575 18.837H5.1738C3.99142 18.837 3 17.8455 3 16.6632V7.39425C3 6.21188 3.99142 5.21875 5.1738 5.21875ZM18.8305 17.7697C19.1357 17.7697 19.3641 17.5787 19.3641 17.2352V17.2343V6.85974C19.3641 6.55455 19.1357 6.32524 18.8305 6.32524H4.6411C4.33591 6.32524 4.1066 6.55455 4.1066 6.85974V17.2352C4.10639 17.2438 4.10639 17.2524 4.1066 17.2611C4.11375 17.5491 4.35305 17.7768 4.6411 17.7697H18.8305Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8088 8.61317L12.1185 12.5422C11.8892 12.7707 11.584 12.7707 11.3172 12.5422L6.62434 8.61317C6.39588 8.46058 6.09069 8.46058 5.89974 8.65153C5.67128 8.87999 5.67128 9.2619 5.9381 9.45285L11.2405 13.8772C11.5073 14.1056 11.9651 14.1056 12.2319 13.8772L17.5343 9.45285C17.7627 9.22268 17.8011 8.84163 17.5718 8.65153V8.65153C17.355 8.4687 17.0428 8.45301 16.8088 8.61317V8.61317Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
}
